import React, { useEffect, useState } from "react";

let deferredInstallEvent = null;

// Capture the browser event as soon as this module loads. Waiting for a React
// effect can miss an early beforeinstallprompt event on fast mobile loads.
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", event => {
    event.preventDefault();
    deferredInstallEvent = event;
    window.dispatchEvent(new Event("wavelines-install-available"));
  });
}

export default function InstallAppPrompt({ appName, logoUrl }) {
  const [event, setEvent] = useState(deferredInstallEvent);
  const [hidden, setHidden] = useState(() => {
    try { return sessionStorage.getItem("install-prompt-hidden") === "1"; }
    catch { return false; }
  });

  const installed =
    window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.navigator.standalone === true;
  const isiOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

  useEffect(() => {
    const syncEvent = () => setEvent(deferredInstallEvent);
    window.addEventListener("wavelines-install-available", syncEvent);
    return () => window.removeEventListener("wavelines-install-available", syncEvent);
  }, []);

  if (installed || hidden) return null;

  const dismiss = () => {
    try { sessionStorage.setItem("install-prompt-hidden", "1"); } catch {}
    setHidden(true);
  };

  const install = async () => {
    if (!event) return;
    event.prompt();
    await event.userChoice;
    deferredInstallEvent = null;
    setEvent(null);
    dismiss();
  };

  const helpText = event
    ? "Add Wavelines ERP to this device for quicker access and offline support."
    : isiOS
      ? "For quicker access, use Share → Add to Home Screen."
      : "To install, open your browser menu and choose Install app or Add to Home screen.";

  return (
    <div
      role="dialog"
      aria-label={"Install " + appName}
      style={{
        position: "fixed", left: 16, right: 16, bottom: 16, zIndex: 9999,
        maxWidth: 520, margin: "0 auto", background: "var(--surface,#111827)",
        color: "var(--text,#fff)", border: "1px solid var(--border,#374151)",
        borderRadius: 16, padding: 16, boxShadow: "0 18px 50px #0008"
      }}
    >
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <img
          src={logoUrl}
          alt={appName + " logo"}
          style={{ width: 52, height: 52, borderRadius: 12, objectFit: "contain", background: "#fff", padding: 4 }}
        />
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 850, fontSize: 15 }}>Install {appName}</div>
          <div style={{ fontSize: 12, opacity: .75, marginTop: 3 }}>{helpText}</div>
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 13 }}>
        <button onClick={dismiss} style={{ padding: "8px 12px", borderRadius: 8, border: "1px solid #6b7280", background: "transparent", color: "inherit" }}>
          Not now
        </button>
        {event && (
          <button onClick={install} style={{ padding: "8px 14px", borderRadius: 8, border: 0, background: "#2563EB", color: "#fff", fontWeight: 800 }}>
            Install app
          </button>
        )}
      </div>
    </div>
  );
}
